import Base = require("../base-command");
import Utils = require("../../utils");

class Keywords {

    static about = `
Compares the command _keywords_ option against the argument _keywords_ to determine if the command should execute.

This is a command helper used by other commands supporting the _keywords_ option. The _validate_ method to performs the work.

    `;

    static validate(command: Base<any>) {
        let myKeywords = Utils.split((command.options["keywords"] || ""));
        let argkeywords = Utils.split(<string>command.findArg("keywords", command.args)["keywords"] || "").filter(v => !!v);
        if (argkeywords.length) {
            if (!myKeywords.length) {
                console.log("no keywords found");
                return false;
            }
            if (!argkeywords.some(keyword => 0 <= myKeywords.indexOf(keyword))) {
                console.log("no keywords match");
                return false;
            }
            console.log("keyword found!");
        }
        return true;
    }

}

export = Keywords;